import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import { ROUTER_CONSTANT } from './constants/routerConstant';
import ProtectedRoute from './ProtectedRoute';

// Index
import Home from './pages/Home/Home';
import AssetLinks from './pages/Asset/AssetLinks';

// Authentication
import CreateNewAccount from './pages/Authentication/CreateNewAccount';
import NewPassword from './pages/Authentication/NewPassword';
import ResetPassword from './pages/Authentication/ResetPassword';
import VerifyUser from './pages/VerifyUser/VerifyUser';
import NotFound from './pages/Error/NotFound';
import Forbidden from './pages/Error/Forbidden';

// Login
import Login from './pages/Authentication/Login';
import Login2 from './pages/Authentication/Login/Login2';
import GrochatLogin from './pages/Authentication/Login/GrochatLogin';
import GrochatMigration from './pages/Authentication/Login/GrochatMigration';
import GrochatCancel from './pages/Authentication/Login/GrochatCancel';

// Notification
import Notification from './pages/Notification/Notification';

// Dashboard
import DashboardPrincipal from './pages/Dashboard/DashboardPrincipal';
import DashboardManager from './pages/Dashboard/DashboardManager';
import DashboardLead from './pages/Dashboard/DashboardLead';
import DashboardOfficer from './pages/Dashboard/DashboardOfficer';

// Ticket List
import TicketListAll from './pages/TicketList/All';
import TicketListNew from './pages/TicketList/New';
import TicketListMember from './pages/TicketList/Member';
import TicketListSolution from './pages/TicketList/Solution';
import TicketDetail from './pages/TicketList/Detail';
import TicketListCreate from './pages/TicketList/Create';

// Contact
import Contact from './pages/Contact/Contact';

// Settings
import CustomerService from './pages/Settings/CustomerService';
import Parameter from './pages/Settings/Parameter';
import ChatBotFlow from './pages/Settings/ChatBotFlow';
import KMSCategory from './pages/Settings/KMS/KMSCategory';
import KMSCategoryAdd from './pages/Settings/KMS/KMSCategoryAdd';
import KMSCategoryDetail from './pages/Settings/KMS/KMSCategoryDetail';
import KMSList from './pages/Settings/KMS/KMSList';
import KMSListAdd from './pages/Settings/KMS/KMSListAdd';
import KMSListDetail from './pages/Settings/KMS/KMSListDetail';
import KMSListEdit from './pages/Settings/KMS/KMSListEdit';
import NewsFeed from './pages/Settings/NewsFeed';
import NewsFeedAdd from './pages/Settings/NewsFeed/Add';
import NewsFeedDetail from './pages/Settings/NewsFeed/Detail';
import NewsFeedEdit from './pages/Settings/NewsFeed/Edit';
import JobProcess from './pages/Settings/JobProcess';
import LoginHistory from './pages/Settings/LoginHistory';
import QueueAssigned from './pages/Settings/Queue/Assigned';
import QueueEscalated from './pages/Settings/Queue/Escalated';
import OnlineUsers from './pages/Settings/OnlineUsers';
import IssueCategory from './pages/Settings/IssueCategory';
import Product from './pages/Settings/IssueCategory/Product';
import Module from './pages/Settings/IssueCategory/Module';
import Complaint from './pages/Settings/IssueCategory/Complaint';
import CommissionScheme from './pages/Settings/CommissionScheme';
import CallHistory from './pages/Settings/CallHistory';

// Master Data
import DataGroup from './pages/MasterData/DataGroup';
import DataGroupAdd from './pages/MasterData/DataGroup/Add';
import DataGroupEdit from './pages/MasterData/DataGroup/Edit';
import DataGroupDetail from './pages/MasterData/DataGroup/Detail';
import Role from './pages/MasterData/Role';
import RoleAdd from './pages/MasterData/Role/Add';
import RoleEdit from './pages/MasterData/Role/Edit';
import RoleDetail from './pages/MasterData/Role/Detail';
import User from './pages/MasterData/User';
import UserAdd from './pages/MasterData/User/Add';
import UserEdit from './pages/MasterData/User/Edit';
import UserDetail from './pages/MasterData/User/Detail';
import DataDistributor from './pages/MasterData/DataDistributor';
import Shift from './pages/MasterData/Shift';
import ShiftAdd from './pages/MasterData/Shift/Add';
import ShiftDetail from './pages/MasterData/Shift/Detail';
import ShiftEdit from './pages/MasterData/Shift/Edit';
import Remark from './pages/MasterData/Remark';
import RootCause from './pages/MasterData/Remark/RootCause';
import Priority from './pages/MasterData/Remark/Priority';
import DocumentHeader from './pages/MasterData/Remark/DocumentHeader';
import KMSFeedback from './pages/MasterData/Remark/KMSFeedback';
import TicketFeedback from './pages/MasterData/Remark/TicketFeedback';
// import ChannelNote from './pages/MasterData/Remark/ChannelNote';
import AutomaticMessage from './pages/MasterData/Remark/AutomaticMessage';
import Escalation from './pages/MasterData/Remark/Escalation';
import ClosedTicket from './pages/MasterData/Remark/ClosedTicket';
import Import from './pages/MasterData/Import';

// Setup
import Profile from './pages/Setup/Profile';

// Report
import PrincipalTicket from './pages/Report/PrincipalTicket';
import ExportTicket from './pages/Report/ExportTicket';

// Voip
import { RTCConfig } from './config/voipConfig';
import GroChatVoipProvider from './components/GroChatVoipProvider/GroChatVoipProvider';
import ringingSound from './assets/audios/phone-calling.mp3';
import hangUpSound from './assets/audios/hang-up.mp3';

class App extends Component {
  render() {
    return (
      <GroChatVoipProvider
        config={RTCConfig}
        user={{
          sign: this.props.authentication?.sign,
          clientId: this.props.authentication?.userDetail?.client_id,
          name: `${this.props.authentication?.userDetail?.first_name} ${this.props.authentication?.userDetail?.last_name}`,
          phone: `+62-${this.props.authentication?.userDetail?.phone}`,
        }}
        ws={this.props.websocket}
        ringingDelay={0}
        ringingVolume={0.5}
        ringingSoundSrc={ringingSound}
        hangUpVolume={0.5}
        hangUpSoundSrc={hangUpSound}
      >
        <Router>
          <Switch>
            {/* Index */}
            <Route exact path={ROUTER_CONSTANT.INDEX} component={Home} />
            <Route exact path={ROUTER_CONSTANT.ASSET_LINKS} component={AssetLinks} />
            {/* Login */}
            <Route exact path={ROUTER_CONSTANT.LOGIN} component={Login} />
            <Route exact path={ROUTER_CONSTANT.LOGIN_SECOND} component={Login2} />
            <Route exact path={ROUTER_CONSTANT.GROCHAT_LOGIN} component={GrochatLogin} />
            <Route exact path={ROUTER_CONSTANT.GROCHAT_MIGRATION} component={GrochatMigration} />
            <Route exact path={ROUTER_CONSTANT.GROCHAT_CANCEL} component={GrochatCancel} />
            {/* Authentication */}
            <Route exact path={ROUTER_CONSTANT.CREATE_NEW_ACCOUNT} component={CreateNewAccount} />
            <Route exact path={ROUTER_CONSTANT.RESET_PASSWORD} component={ResetPassword} />
            <Route exact path={ROUTER_CONSTANT.NEW_PASSWORD} component={NewPassword} />
            <Route exact path={ROUTER_CONSTANT.VERIFY_USER} component={VerifyUser} />
            {/* Notification */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.NOTIFICATION} component={Notification} />
            {/* Dashboard */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.DASHBOARD_PRINCIPAL} component={DashboardPrincipal} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.DASHBOARD_MANAGER} component={DashboardManager} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.DASHBOARD_LEAD} component={DashboardLead} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.DASHBOARD_OFFICER} component={DashboardOfficer} />
            {/* Ticket List */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_LIST_NEW} component={TicketListNew} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_DETAIL_NEW} component={TicketDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_LIST_ALL} component={TicketListAll} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_DETAIL_ALL} component={TicketDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_LIST_MEMBER} component={TicketListMember} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_DETAIL_MEMBER} component={TicketDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_LIST_SOLUTION} component={TicketListSolution} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_DETAIL_SOLUTION} component={TicketDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.TICKET_LIST_CREATE} component={TicketListCreate} />
            {/* Contact */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.CONTACT} component={Contact} />
            {/* Settings */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_CS_AGENT} component={CustomerService} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_PARAMETER} component={Parameter} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW} component={ChatBotFlow} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY} component={KMSCategory} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY_ADD} component={KMSCategoryAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY_DETAIL} component={KMSCategoryDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_LIST} component={KMSList} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_LIST_ADD} component={KMSListAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_LIST_DETAIL} component={KMSListDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_KMS_LIST_EDIT} component={KMSListEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_NEWS_FEED} component={NewsFeed} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_NEWS_FEED_ADD} component={NewsFeedAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_NEWS_FEED_DETAIL} component={NewsFeedDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_NEWS_FEED_EDIT} component={NewsFeedEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_MONITORING} component={JobProcess} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY} component={LoginHistory} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_QUEUE_ASSIGNED} component={QueueAssigned} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_QUEUE_ESCALATED} component={QueueEscalated} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_SESSION} component={OnlineUsers} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY} component={IssueCategory} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_PRODUCT} component={Product} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_MODULE} component={Module} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_COMPLAINT} component={Complaint} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME} component={CommissionScheme} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETTINGS_CALL_HISTORY} component={CallHistory} />
            {/* Master Data */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP} component={DataGroup} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP_ADD} component={DataGroupAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP_DETAIL} component={DataGroupDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP_EDIT} component={DataGroupEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_ROLE} component={Role} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_ROLE_ADD} component={RoleAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_ROLE_DETAIL} component={RoleDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_ROLE_EDIT} component={RoleEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_USER} component={User} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_USER_ADD} component={UserAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_USER_EDIT} component={UserEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_USER_DETAIL} component={UserDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER} component={DataDistributor} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_SHIFT} component={Shift} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_SHIFT_ADD} component={ShiftAdd} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_SHIFT_DETAIL} component={ShiftDetail} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_SHIFT_EDIT} component={ShiftEdit} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK} component={Remark} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_ROOT_CAUSE} component={RootCause} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_PRIORITY} component={Priority} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_DOCUMENT_HEADER} component={DocumentHeader} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_KMS_FEEDBACK} component={KMSFeedback} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_TICKET_FEEDBACK} component={TicketFeedback} />
            {/* <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_CHANNEL_NOTE} component={ChannelNote} /> */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_AUTOMATIC_MESSAGE} component={AutomaticMessage} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_ESCALATION} component={Escalation} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_REMARK_CLOSED_TICKET} component={ClosedTicket} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.MASTER_DATA_IMPORT} component={Import} />
            {/* Setup */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS} component={Profile} />
            {/* Report */}
            <ProtectedRoute exact path={ROUTER_CONSTANT.REPORT_EXPORT_TICKET} component={ExportTicket} />
            <ProtectedRoute exact path={ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET} component={PrincipalTicket} />
            {/* Etc */}
            <Route exact path={ROUTER_CONSTANT.FORBIDDEN} component={Forbidden} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </GroChatVoipProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    websocket: state.grochatWebsocket.websocket
  };
};

export default connect(mapStateToProps)(App);